import { formatUnits, hexToBytes } from '@train-protocol/sdk';
import { requireSigner, getContractInstance, findEventDataFromLogs, parseSecret } from '../helpers';
export async function getUserLockDetails(rpcUrl, node, signer, params) {
    const validSigner = requireSigner(signer);
    const { id, contractAddress, txId } = params;
    const { contract, userAztecAddress } = await getContractInstance(contractAddress, validSigner, node);
    const hashlockBytes = hexToBytes(id, 32);
    const result = await contract.methods
        .get_user_lock(hashlockBytes)
        .simulate({ from: userAztecAddress });
    const parsedResult = resolveUserLock(result.result, id, params.decimals);
    if (!parsedResult)
        return null;
    let eventDerivedData = {};
    if (txId) {
        eventDerivedData = await findEventDataFromLogs(node, txId, id);
    }
    return { ...parsedResult, ...eventDerivedData };
}
export function resolveUserLock(result, id, decimals) {
    const status = Number(result.status);
    if (status === 0)
        return null;
    return {
        hashlock: id,
        amount: Number(formatUnits(BigInt(result.amount), decimals)),
        secret: parseSecret(result.secret),
        timelock: Number(result.timelock),
        status,
        sender: result.refund_to?.toString() ?? '',
        recipient: result.recipient?.toString() ?? '',
        token: result.token?.toString() ?? '',
    };
}
